import { CanDeactivateFn } from '@angular/router';

/** Implemented by any screen that can hold an un-committed import. */
export interface HasUnsavedImport {
  hasUnsavedImport(): boolean;
}

/**
 * Blocks navigation away from the Data Import screen while a validated file is still
 * waiting to be imported. Uploading only *checks* the file, so leaving at that point
 * silently discards the work — which reads as "the import didn't do anything".
 */
export const unsavedImportGuard: CanDeactivateFn<HasUnsavedImport> = (component) => {
  if (!component?.hasUnsavedImport?.()) return true;

  return confirm(
    'Your file has been checked but not imported yet — nothing has been saved.\n\n' +
      'Leave this page and discard it?',
  );
};
